<div class="d-flex align-items-center mt-5">
  <div class="symbol symbol-100 mr-5">
    <div
      class="symbol-label edit-hover cursor-pointer"
      (click)="editAvatar()"
      [ngStyle]="{
        'background-image': userimg
      }"
    >
      <div class="edit"><span class="material-icons text-secondary"> mode_edit </span></div>
    </div>
    <i class="symbol-badge bg-success"></i>
  </div>
  <div class="d-flex flex-column">
    <h6
      href="#"
      class="font-weight-bold font-size-h5 text-dark text-hover-primary text-capitalize"
    >
      {{ username }}
  </h6>
    <div class="text-muted mt-1 text-capitalize">{{ render_desigination(designation) }}</div>

    <a
      (click)="signout()"
      routerLink="/login"
      class="btn btn-light-primary btn-bold mt-5"
    >
      Sign Out
    </a>
  </div>
</div>

<div class="separator separator-dashed mt-8 mb-5"></div>
